import { useState } from "react";
import {Link} from "react-router";
import Label from "../form/Label.js";
import Input from "../form/input/InputField.js";
import Button from "../ui/button/Button.js";
import {auth} from '../../../config/firebase.js';
import { sendPasswordResetEmail } from 'firebase/auth';
import Alert from "../ui/alert/Alert.js";
import {useAuthError} from "../../hooks/useAuthError.js";
import { requiresGoogleSignIn } from "../../utils/authUtils";

export default function ResetPasswordForm() {
  const [email, setEmail] = useState('');
  const [error, setError] = useState("");
  const [showSuccess, setShowSuccess] = useState(false);
  const { authError, handleAuthError, clearAuthError } = useAuthError();

  const handleResetPassword = async (e: any) => {
    e.preventDefault();
    setShowSuccess(false);
    if (!email) {
      setError("Missing email");
      return;
    }
    if (requiresGoogleSignIn(email)) {
      setError("@chargemont.com accounts use Google Sign-In and don't have a password to reset.");
      return;
    }
    setError('');
    clearAuthError();

    try {
      await sendPasswordResetEmail(auth, email);
      setShowSuccess(true);
    } catch (e) {
      handleAuthError(e);
    }
  };

  return (
    <div className="flex flex-col flex-1">
      <div className="flex flex-col justify-center flex-1 w-full max-w-md mx-auto">
        <div>
          <div className="mb-5 sm:mb-8">
            <h1 className="mb-2 font-semibold text-gray-800 text-title-sm dark:text-white/90 sm:text-title-md">
            Forgot Your Password?
            </h1>
            <p className="text-sm text-gray-500 dark:text-gray-400">
            Enter the email address linked to your account, and we’ll send you a link to reset your password.
            </p>
          </div>
          <div>
            <form onSubmit={handleResetPassword}>
              <div className="space-y-6">
                <div>
                  <Label>
                    Email <span className="text-error-500">*</span>{" "}
                  </Label>
                  <Input
                    placeholder="info@gmail.com"
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </div>
                <div>
                  {error && (
                    <Alert
                      variant="error"
                      title={error}
                      showLink={false}
                    />
                  )}
                </div>
                <div>
                  {!error && authError && (
                    <Alert
                      variant="error"
                      title={authError}
                      showLink={false}
                    />
                  )}
                </div>
                <div>
                  {showSuccess && (
                    <Alert
                      variant="success"
                      title="Email sent. Check your mailbox! Don't forget to look in SPAM folder as well."
                      showLink={false}
                    />
                  )}
                </div>
                <div>
                  <Button className="w-full" size="sm">
                    Send Reset Link
                  </Button>
                </div>
              </div>
            </form>

            <div className="mt-5">
              <p className="text-sm font-normal text-center text-gray-700 dark:text-gray-400 sm:text-start">
                Back to {""}
                <Link
                  to="/signin"
                  className="text-brand-500 hover:text-brand-600 dark:text-brand-400"
                >
                  Sign In
                </Link>
              </p>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
}
